export default __webpack_public_path__ + "static/media/gdprlogo.50ae1427.png";